<template>
    <section class="w-full">
        <slot></slot>
    </section>
</template>
